export const DASHBOARD = '/dashboard';
export const SEARCH_CHECK = '/check';
export const SEARCH_CHECK_DETAIL = '/maintain-check';
export const TBILL_RATES = '/tBill';
export const INIT_CMS64_REPORTS = '/initCorrectCms64Report';
export const TBILL_RATES_DETAIL = '';
export const DRUG_FAMILY = '/drugFamily';
export const DRUG_FAMILY_DETAIL = '/drugFamilyDetail';
export const MAINTAIN_CLIENT = '/client';
export const MAINTAIN_CLIENT_DETAIL = '';
export const UNIT_CONVERSION = '/unitConversion';
export const UNIT_CONVERSION_DETAIL = '/unitConversion-detail';
export const MANUFACTURER = '/manufacturer';
export const MANUFACTURER_DETAIL = '/manufacturer-detail';
export const EXCLUDE_NDC = '/excludedNDCs';
export const EXCLUDE_NDC_DETAIL = '/excludedNDCsDetail';
export const CHECK = '/check';
export const CHECK_DETAIL = '/maintain-check';
export const REQUEST_CLAIM_AUDIT = '/RequestClaimAudit';
export const LOG_BATCH_TOTAL = '/logBatchSearch';
export const LOG_BATCH_TOTAL_DETAIL = '/logBatchDetail';
export const ASSIGN_DISPUTES = '/assignDisputesSearch';
export const ASSIGN_DISPUTES_DETAIL = '/assignDisputesDetails';
export const VIEW_CHECKS_BY_ASSOCIATED_INVOICES = '/checksByInvoice';
export const LOG_CHECK = '/log-check';
export const COMMENT_AND_CORRESPONDENCE = '/comment';
export const REQUEST_MAILING_LABELS = '/MailingLabel';
export const REQUEST_MAILING_LABELS_DETAIL = '';
export const LABELER_DIFFERENCES = '/labelerDifferences';
export const LABELER_DIFFERENCES_DETAIL = '';
export const INVOICE_AUDITS = '/invoiceAudits';
export const INVOICE_AUDITS_DETAIL = '/invoiceAuditsDetail';
export const CMS_MISMATCH = '/cmsMismatch';
export const CMS_MISMATCH_DETAIL = '/cmsMismatchDetail';
export const LINK_NEW_DRUG_TO_DRUG_FAMILY = '/linknewdrugstodrugfamily';
export const CALCULATE_INTEREST = '/calculateInterest';
export const LETTER_TEMPLATE = '/letterTemplate';
export const LETTER_TEMPLATE_DETAIL = '/letterTemplateDetail';
export const VIEW_CHECK_ALLOCATIONS = '/searchViewCheckAllocation';
export const VIEW_CHECK_ALLOCATIONS_DETAIL = '/checkAllocDetail';
export const CMS_ROSI_DISCREPANCIES = '/cmsRosi';
export const CMS_ROSI_DISCREPANCIES_DETAIL = '/cmsRosiDetails';
export const DISPUTES = '/disputes';
export const DISPUTES_DETAIL = '';
export const CLAIM_AUDITS = '/claimAuditSelect';
export const CLAIM_AUDITS_DETAIL = '/ClaimAuditViewDetails';
export const CMS_DRUG_FILE_DISCREPANCIES = '/cmsDrugFileDiscrepancies';
export const CMS_DRUG_FILE_DISCREPANCIES_DETAIL = '/cmsDrugFileDetail';
export const CONTRACT = '/contract';
export const CONTRACT_DETAIL = '/createContract';
export const UNDER_THRESHOLD_INVOICES = '/underThresholdInvoice';
export const UNDER_THRESHOLD_INVOICES_DETAIL = '/invoiceAuditsDetail';
export const SUSPENDED_CHECKS = '/suspendedCheck';
export const ROSI_PQAS_INCONSISTENCIES = '/rosiInconsistencies';
export const ROSI_PQAS_INCONSISTENCIES_DETAIL = '/rosiInconsistenciesDetail';

export const CONTACT_ANOMALIES = '/contactAnomalies';

export const REBATE_PRICE_LEVEL = '/priceLevel';
export const REBATE_PRICE_LEVEL_DETAIL = '/priceDetails';

export const REBATE_PROGRAM = '/SearchRebate';
export const REBATE_PROGRAM_DETAIL = '/maintainRebate';
export const REBATE_PROGRAM_CREATE = '/createRebate';

export const CREATE_LETTER = '/createLetter';
export const CREATE_LETTER_DETAIL = '/createLetterDetail';

export const ACCOUNTS_RECEIVABLE = '/reqAccReceivable';
export const ACCOUNTS_RECEIVABLE_NDC_DETAIL_ALL = '/AccRecNDCDetailAll';
export const ACCOUNTS_RECEIVABLE_NDC_DETAIL = '/AccRecNDCDetail';
export const ACCOUNTS_RECEIVABLE_NDC_ACTIVITY = '/AccRecNDCActivity';
export const ACCOUNTS_RECEIVABLE_SUBSYSTEM_OVERVIEW = '';
export const ACCOUNTS_RECEIVABLE_SUMMARY_BY_MANUFACTURER = '/arSummaryByMfg';
export const ACCOUNTS_RECEIVABLE_SUMMARY_BY_MANUFACTURER_ALL =
  '/arSummaryByMfgAll';
export const ACCOUNTS_RECEIVABLE_SUMMARY_BY_QUARTER = '/ARSummaryByQtr';
export const ACCOUNTS_RECEIVABLE_SUMMARY_BY_QUARTER_ALL = '/ARSummaryByQtrAll';
export const MANUFACTURER_ACCOUNTS_RECEIVABLE = '/mfgAccountRec';
export const MANUFACTURER_ACCOUNTS_RECEIVABLE_ARM = '/ARManufacturer';
export const QUARTERLY_ACCOUNTS_RECEIVABLE = '/QtrAccountsRec';
export const QUARTERLY_ACCOUNTS_RECEIVABLE_ALL = '/QtrAccountsRecAll';
export const PERFORM_DISPUTE = '/requestCurrentDisputeDisplay';
export const PERFORM_DISPUTE_DETAIL = '/displayCurrentDisputes';
export const PERFORM_DISPUTE_SUMMARY = '/providerSummary';
export const PERFORM_DISPUTE_CLAIMS_DETAIL = '/disputedClaimsDetail';
export const PERFORM_DISPUTE_NDC_HISTORY = '/ndcHistory';

export const REBATE_PRICE_SEARCH = '/rebatePriceSearch';
export const REBATE_PRICE_DETAIL = '/rebatePriceDetails';

export const DISPLAY_LETTER = '/letter';
export const DISPLAY_LETTER_DETAIL = '/letterTemplateDetail';

export const GENERATE_COLLECTION_LETTER = '/GenerateCollectionLetter';
export const GENERATE_COLLECTION_LETTER_DETAIL = '/Collectionletterdetail';
export const RECORD_PROVIDER_PREVIEW = '/providerReview';
export const RECORD_PROVIDER_PREVIEW_DETAIL = '/providerReviewDetail';

export const ALLOCATE_PAYMENT_SEARCH = '/allocatePayment';
export const ALLOCATE_PAYMENT_PICK_AN_INVOICE =
  '/pickInvoiceAssociateWithCheck';
export const ALLOCATE_PAYMENT_ROSI_PQAS = '/allocatePaymentDetail';

export const ADD_PREVIOUS_OMITTED_CLAIMS = '/requestedPreviousClaim';
export const RESEARCH_EXTS_CMS64_RPT = '/researchexisitngcms64report';
export const RESEARCH_EXTS_CMS64_RPT_DETAILS =
  '/researchexisitngcms64reportdetails';
export const CREATE_CMS64_RPT = '/reqInitCorrectCmsReport';
export const CREATE_CMS64_RPT_DETAILS = '/initCorrectCms64Report';
export const INVOICE_REPORT = '/request-invoice-report';
export const INVOICE_REPORT_DETAILS = '/invoice-report-details';

export const PROVIDER = '/provider';
export const PROVIDER_DETAILS = '/providerDetails';
export const INVOICE_DETAILS = '/request-invoice-detail';
export const INVOICE_DETAILS_DISPLAY = '/display-invoice';
export const NDC = '/ndc';
export const NDC_DETAILS = '/ndc-details';
export const CLAIM = '/claim';
export const SELECTED_CLAIM = '/selected-claim';
export const CHECKS = '/checks';
export const DISPLAY_CHECK = '/display-check';
export const LETTER = '/letter';
export const LETTER_DETAILS = '/displayLetterDetail';
export const URA_SEARCH = '/ura-search';
export const URA_SELECTED = '/selected-ura';
export const DRUG_PRICE_LOAD = '/RequestDrugPriceLoad';
export const DRUG_PRICE_LOAD_DETAILS = '/RequestDrugPriceLoadDetails';
export const REQ_URA_CALCULATION = '/requestURACalculation';
export const REQ_INVOICE_CALCULATION = '/requestInvoiceCalculation';
export const RECORD_MAILING_DATE = '/recordMailingDate';
export const FREEZE_INVOICES = '/freezeInvoice';
export const GENERATE_INVOICES = '/generateInvoice';
export const GENERATE_INVOICE_DETAILS = '/generateInvoiceDetail';
export const MAINTAIN = '/maintain';
export const MAINTAIN_GROUP = '/group';
export const GROUP_MAINTAIN = '/group-maintain';
export const MAINTAIN_PLAN = '/plan';
export const PLAN = '/createNewPlan';
export const MAINTAIN_INELIGIBLE_PROVIDERS = '/ineligibleProviders';
export const MAINTAIN_EXCLUDED_NDCS = '/excludedNDCs';
export const MAINTAIN_EXCLUDED_NDCS_DETAIL = '/excludedNDCsDetail';
export const MAINTAIN_CMS_MAT_DRUGS = '/MaintainCMSMatDrugs';
export const MAINTAIN_SYSTEM_PARAMETERS = '/systemparameter';
export const EXAMINING_PROCEDURE_RESULTS = '/ProcedureResults';
export const EXAMINING_PROCEDURE_RESULTS_DETAILS = '/ProcedureResultDetails';
export const MAINTAIN_USER_DEFAULTS = '/userDefault';
export const MAINTAIN_CODE_TABLES = '/codeTable';
export const MAINTAIN_CONTACT_TYPES = '/contactType';
export const MAINTAIN_PRICE_TYPES = '/priceType';
export const QUARTERLY_MARKETING_DATA = '/quarterlyMarketingData';
export const QUARTERLY_MARKETING_DATA_DETAILS =
  '/quarterlyMarketingDataTableDetails';
export const PERIODIC_BALANCE_REPORT = '/periodicBalanceRpt';
export const TRANSITION_DATA = '/transitionData';
export const ONLINE_FIXES = '/onlineFixes';
export const CLAIM_GROUPING_PARAMETERS = '/claimGroupingParameter';
export const CLAIM_GROUPING_PARAMETERS_DETAIL = '/claimGroupingParameterDetail';
export const CREATE_UTILIZATION_TAPE = '/createUtilizationTape';
export const DISPLAY_CLAIM_DETAIL = '/claimDetails';
export const VIEW_CALCULATED_INTEREST = '/view-calculated-interest';
export const VIEW_CALCULATED_INTEREST_DETAILS = '/calculated-interest-details';
export const USER_LIST = '/userList';
export const UNITS_CLAIM = '/units-claim';
export const UNITS_SELECTED_CLAIM = '/units-selected-claim';

// Summary Report
export const PAYMENT_SUMMARY_REPORT = '/paymentSummary';
export const REBATE_SUMMARY_REPORT = '/rebatesummary';
export const REBATE_PERCENT_SPEND_REPORT = '/percentSpend';
export const INVOICE_REGISTER_REPORT = '/invoiceRegister';
export const QUARTERLY_PAYMENT_REPORT = '/quarterlyPayment1';
export const INVOICE_QTR_NOT_PAID_REPORT = '/reqInvoicesQtrnotPaid';
export const TOP_BALANCE_REPORT = '/topBalances';
export const DRUG_TYPE_SUMMARY_REPORT = '/drugTypeSummary';
export const DISPUTE_AMOUNT_REPORT = '/disputeAmounts';
export const DISPUTE_ACTIVITY_REPORT = '/disputeActivity';
export const DISPUTE_CODE_REPORT = '/disputeCodes';

// Details Reports
export const UNALLOCATED_BALANCE_REPORT = '/unallocatedBalance';
export const CHECK_ALLOCATION_COMPARISION_REPORT = '/checkallocationcomparison';
export const CURRENT_ZERO_URA_REPORT = '/currentZeroURA';
export const NDC_DETAILS_REPORT = '/ndcdetails';
export const NDC_HISTORY_REPORT = '/ndchistoryreport';
export const CONTRACT_REPORT = '/contractreport';
export const DISPUTE_RECAPITULATION_REPORT = '/disputeRecapitulation';
export const HCPCS_CODE_CLAIMS_PAID_REPORT = '/hcpcsCodeClaimsPaid';
export const INTEREST_OVERRIDE_REPORT = '/interestOverride';
export const ROSI_PQAS_REPORT = '/rosi_pqas';
export const MANUFACTURER_SUMMARY_REPORT = '/manufacturerSummary';
export const ADJUSTED_CLAIMS_REPORT = '/adjustedClaims';
export const MCO_CLAIMS_REPORT = '/mco_claims';
export const PROVIDER_CLAIMS_LISTING_REPORT = '/providerClaimListing';

// State Reports
export const EXCLUDED_CLAIMS_REPORT = '/excludedClaims';
export const CHIP_CSHCN_RATES_REPORT = '/chipCshcnRates';
export const CHIP_CSHCN_RATES_AUDIT_REPORT = '/chipCshcnRateAudit';
export const ZERO_URA_REPORT = '/zeroURA';
export const INTEREST_RECEIVED_REPORT = '/interestRecieved';
export const OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_REPORT =
  '/outstandingDisputesForNumOfDays';
export const OUTSTANDING_DISPUTES_FOR_QUARTER_REPORT =
  '/outstandingDisputesForQuarter';
export const ADJUSTMENT_BY_REASON_CODE_REPORT = '/adjustmentByReasonCode';
export const QUARTERLY_CMS_UROA_REPORT = '/cmsUra';
export const INSTITUTIONAL_CLAIMS_UNIT_TYPE_DISCREPANCY_REPORT =
  '/institionalClaimsTypeDiscrepancy';
export const QUARTERLY_CMS_DRUG_REPORT = '/cmsDrug';
export const B_PROVIDER_CLAIMS_REPORT = '/340BProviderClaims';
export const PROGRAM_ELIGIBILITY_CATEGORY_REPORT =
  '/programAndEligibilityCategory';
export const TOTAL_DOLLARS_PAID_REPORT = '/totaldollarspaid';
export const PRE_INVOICE_UNIT_ADJUSTMENT_REPORT = '/PreInvoiceUnitAdjustment';
export const CURRENT_TO_PREVIOUS_QTR_INVOICE_COMPARIRION_REPORT =
  '/currentToPreviousQuarterInvoiceComparison';
export const CASH_RECEIPT_SUMMARY_REPORT = '/cashReceiptSummary';
export const CMS_ADJUSTMENT_DETAIL_REPORT = '/cmsReportAdjustmentDetail';
export const OUTSTANDING_BALANCE_BY_LABERER_AND_QUARTER_REPORT =
  '/outstandingBalanaceByLabererAndQuarter';
export const MANUFACTURER_OUTSTANDING_BALANCE_REPORT =
  '/manufacturerOutstandingBalance';
export const NDC_PAYMENT_REPORT = '/ndcPayment';
export const FAMILY_PLANNING_DRUG_INVOICED_REBATES_REPORT =
  '/familyPlanningDrugsInvoicedforRebates';
export const FAMILY_PLANNING_DRUGS_PAYMENT_RECEIVED_REPORT =
  '/familyPlanningDrugsPaymentReceived';
export const ACTIVE_LABERER_REPORT = '/activeLabeler';
export const TERMINATED_LABELER_REPORT = '/terminatedlabeler';
export const MONTHLY_CLAIMS_RECONCILIATION_REPORT =
  '/monthlyclaimsreconcilliation';
export const QUARTERLY_CLAIMS_RECONCILIATION_REPORT =
  '/quarterlyclaimsreconcilliation';
export const DRUG_THERAPEUTIC_CLASS_REPORT = '/drugsTherapeuticClass';
export const SUPPLEMENTAL_RATES_REPORT = '/supplementalRates';
export const UNIT_ADJUSTMENTS_AT_NDC_LEVEL_REPORT = '/unitAdjustmentatNdcLevel';
export const SUBSTANCE_ABUSE_DRUG_REPORT = '/substanceAbuseDrug';
export const RIDER_REPORT = '/rider';
export const CMS_QUARTERLY_REPORT = '/CMSQuarterlyReporting';

// Display Summary Report
export const DISPLAY_PAYMENT_SUMMARY_REPORT = '/displaypaymentsummary';
export const DISPLAY_REBATE_PERCENT_SPEND_REPORT = '/maufacturer';
export const DISPLAY_INVOICE_REGISTER_REPORT = '/invoice';
export const DISPLAY_QUARTERLY_PAYMENT_REPORT = '/quarterlyPaymentDisplay';
export const DISPLAY_INVOICE_QTR_NOT_PAID_REPORT =
  '/invoicesforQtrnotPaidDetail';
export const DISPLAY_TOP_BALANCE_REPORT = '/displaytopbalances';
export const DISPLAY_DRUG_TYPE_SUMMARY_REPORT = '/displayDrugTypeSummary';
export const DISPLAY_DISPUTE_AMOUNT_REPORT =
  '/displayManufacturerDisputedAmounts';
export const DISPLAY_DISPUTE_ACTIVITY_REPORT = '/displayDisputeActivity';
export const DISPLAY_DISPUTE_CODE_REPORT = '/displayDisputeCodes';

// Display Detail Report
export const DISPLAY_UNALLOCATED_BALANCE_REPORT = '/unallocated-balance-report';
export const DISPLAY_CHECK_ALLOCATION_COMPARISION_REPORT =
  '/checkallocationcomparisiondispaly';
export const DISPLAY_CURRENT_ZERO_URA_REPORT = '/dispCurrentZeroURA';
export const DISPLAY_NDC_DETAILS_REPORT = '/ndcdetailsdisplay';
export const DISPLAY_NDC_HISTORY_REPORT = '/ndchistorydisplay';
export const DISPLAY_DISPUTE_RECAPITULATION_REPORT =
  '/displayDisputeRecapitulation';
export const DISPLAY_HCPCS_CODE_CLAIMS_PAID_REPORT = '/displayHcpcsCode';
export const DISPLAY_INTEREST_OVERRIDE_REPORT = '/interestOverrideDetail';
export const DISPLAY_ROSI_PQAS_REPORT = '/displayrosi_pqas';
export const DISPLAY_MANUFACTURER_SUMMARY_REPORT = '/dispManufacturerSummary';
export const DISPLAY_ADJUSTED_CLAIMS_REPORT = '/DisplayAdjustedClaims';
export const DISPLAY_MCO_CLAIMS_REPORT = '/display_mco_claims';
export const DISPLAY_PROVIDER_CLAIMS_LISTING_REPORT =
  '/displayProviderClaimListing';

// Display State Report
export const DISPLAY_EXCLUDED_CLAIMS_REPORT = '/dispExcludedClaims';
export const DISPLAY_CHIP_CSHCN_RATES_REPORT = '/dispChipCshcnReport';
export const DISPLAY_CHIP_CSHCN_RATES_AUDIT_REPORT = '/dispChipCshcnRateAudit';
export const DISPLAY_ZERO_URA_REPORT = '/dispZeroURA';
export const DISPLAY_INTEREST_RECEIVED_REPORT = '/interestRecivedDetail';
export const DISPLAY_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_REPORT =
  '/dispOutstandingDisputeNumOfDays';
export const DISPLAY_OUTSTANDING_DISPUTES_FOR_QUARTER_REPORT =
  '/displayOutstandingDisputesForQuarter';
export const DISPLAY_ADJUSTMENT_BY_REASON_CODE_REPORT =
  '/dispAdjustmentByReasonCode';
export const DISPLAY_QUARTERLY_CMS_UROA_REPORT = '/displaycmsUra';
export const DISPLAY_INSTITUTIONAL_CLAIMS_UNIT_TYPE_DISCREPANCY_REPORT =
  '/dispInstitionalClaimsTypeDiscrepancy';
export const DISPLAY_QUARTERLY_CMS_DRUG_REPORT = '/displayCmsDrug';
export const DISPLAY_B_PROVIDER_CLAIMS_REPORT = '/display340BProviderClaims';
export const DISPLAY_PROGRAM_ELIGIBILITY_CATEGORY_REPORT =
  '/displayProgramAndEligibilityCategory';
export const DISPLAY_PRE_INVOICE_UNIT_ADJUSTMENT_REPORT =
  '/DisplayPreInvoiceUnitAdjustment';
export const DISPLAY_CURRENT_TO_PREVIOUS_QTR_INVOICE_COMPARIRION_REPORT =
  '/displayCurrentToPreviousQuarterInvoiceComparison';
export const DISPLAY_CASH_RECEIPT_SUMMARY_REPORT = '/dispCashReceiptSummary';
export const DISPLAY_CMS_ADJUSTMENT_DETAIL_REPORT =
  '/displayCmsReportAdjustmentDetail';
export const DISPLAY_OUTSTANDING_BALANCE_BY_LABERER_AND_QUARTER_REPORT =
  '/disOutstandingBalanaceByLabererAndQuarter';
export const DISPLAY_MANUFACTURER_OUTSTANDING_BALANCE_REPORT =
  '/displayManufacturerOutstandingBalance';
export const DISPLAY_NDC_PAYMENT_REPORT = '/dispNDCPayment';
export const DISPLAY_FAMILY_PLANNING_DRUG_INVOICED_REBATES_REPORT =
  '/DisplayFamilyPlanningDrugsInvoicedRebates';
export const DISPLAY_FAMILY_PLANNING_DRUGS_PAYMENT_RECEIVED_REPORT =
  '/DisplayFamilyPlanningDrugsPmtRec';
export const DISPLAY_ACTIVE_LABERER_REPORT = '/displayActiveLabeler';
export const DISPLAY_TERMINATED_LABELER_REPORT = '/terminatedlabelerdisplay';
export const DISPLAY_MONTHLY_CLAIMS_RECONCILIATION_REPORT =
  '/monthlyclaimsreconcilliationdetails';
export const DISPLAY_QUARTERLY_CLAIMS_RECONCILIATION_REPORT =
  '/quarterlyclaimsreconcilliationdetails';
export const DISPLAY_DRUG_THERAPEUTIC_CLASS_REPORT =
  '/displayDrugsTherapeuticClass';
export const DISPLAY_SUPPLEMENTAL_RATES_REPORT = '/displaySupplementalRates';
export const DISPLAY_UNIT_ADJUSTMENTS_AT_NDC_LEVEL_REPORT =
  '/displayUnitAdjustmentatNdcLevel';
export const DISPLAY_SUBSTANCE_ABUSE_DRUG_REPORT = '/displaSubstanceAbuseDrug';
export const DISPLAY_RIDER_REPORT = '/riderdetails';
export const DISPLAY_CMS_QUARTERLY_REPORT = '/DisplayCMSQuarterlyReporting';
// Footer Links Starts
export const SITE_MAP = '/SiteMap';
export const FOOTER_LINKS = '/FooterLinks';
export const WIP_FOOTER_LINKS = '/WIPFooterLinks';
export const REMINDER = '/reminderSetup';
export const RECEIPT = '/reminderRecipients';
export const SYSTEM_REMINDER = '/systemReminders';
export const DATA_NICHE = '/requestDataNicheReport';




